const identityProviders = {
    azure: "azure",
    gsuite: "gsuite"

};

module.exports = { identityProviders };
